import { useEffect } from 'react';
import { Platform } from 'react-native';
import { useCurrentTheme } from '@/theming/useCurrentTheme';

export function useWebBodyBackground() {
    const { theme } = useCurrentTheme();

    useEffect(() => {
        if (Platform.OS === 'web') {
            document.body.style.backgroundColor = theme.colors.background;
        }
    }, [theme.colors.background]);
}
